import { LMS_ASSERTION_PARAM_KEYS } from '../../../utils/lmsLaunch';

/**
 * Remove assertion JWT from the address bar (history.replaceState).
 * Never logs param values.
 */
export function stripAssertionFromUrl(
  paramKeys: readonly string[] = LMS_ASSERTION_PARAM_KEYS
): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const url = new URL(window.location.href);
  let changed = false;
  for (const key of paramKeys) {
    if (url.searchParams.has(key)) {
      url.searchParams.delete(key);
      changed = true;
    }
  }
  if (!changed) {
    return false;
  }
  const next = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState(window.history.state, '', next);
  return true;
}
